import { EntityTypes } from '@/helpers/entityType';

export default {
  __typename: EntityTypes.destination,
  id: 7,
  slug: 'london',
  title: 'London',
};
